import { cn } from "@/utils/utils";
import type { FC } from "react";
import { Badge } from "./badge";

type StatusPillVariant = "active" | "inactive" | "draft";

/**
 * Course-list status chip. Reuses design-system Badge so Active/Inactive
 * match school/class lists exactly.
 */
export const StatusPill: FC<{
  variant: StatusPillVariant;
  label: string;
  className?: string;
}> = ({ variant, label, className }) => {
  if (variant === "draft") {
    return (
      <Badge
        variant="primary"
        className={cn(
          "border-[#DADDE2] bg-[#F6F7FA] text-[#1F1F1F]",
          className
        )}
      >
        {label}
      </Badge>
    );
  }

  return (
    <Badge
      variant={variant === "active" ? "success" : "danger"}
      className={className}
    >
      {label}
    </Badge>
  );
};
